import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSapIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Capa_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	width: "548.291px",
	height: "548.291px",
	viewBox: "0 0 548.291 548.291",
	style: { enableBackground: "new 0 0 548.291 548.291" },
	xmlSpace: "preserve",
	...props,
	children: [
		/* @__PURE__ */ _jsx("polygon", {
			className: "st0",
			points: "260.9 330.6 241.3 271.2 240.6 271.2 220.3 330.6 260.9 330.6"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M394.2,250.9l-30.1-.2v45.4h30.1c14.3,0,23.3-9,23.3-22.6s-9-22.6-23.3-22.6Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M359.1,521H65.4v-103.6h354.8v24.6s21.5,0,21.5,0v-24.6h13.2c17,0,30.7-13.8,30.7-30.7v-159.8c0-17-13.8-30.8-30.8-30.8h-13.2v-63.5c0-.4,0-.8,0-1.2,0-2.5-.8-5-2.6-7L333.3,3.7s0,0,0,0c-.6-.7-1.4-1.3-2.1-1.8-.2-.2-.5-.3-.7-.4-.7-.4-1.4-.7-2.1-.9-.2,0-.4,0-.6-.2-.8-.2-1.6-.3-2.5-.3H65.4c-11.9,0-21.5,9.6-21.5,21.5v174.6h-13.2c-17,0-30.7,13.8-30.7,30.7v159.8c0,17,13.8,30.7,30.7,30.7h13.2v109.4c0,11.9,9.6,21.5,21.5,21.5h312.7l-19-27.2ZM279,386.3l-9.8-28.6h-58l-9.8,28.6h-33.1l59.5-163.3h24.8l59.5,163.3s-33.1,0-33.1,0ZM449.1,274.2c0,27.9-19,50.5-52.9,50.5h-.5s-31.6,0-31.6,0v61.7h-31.6v-163.3h63.2c33.9,0,53.4,23.3,53.4,51.2ZM65.4,21.5h249.1v110c0,5.9,4.8,10.8,10.8,10.8h95v53.9H65.4V21.5ZM36.6,366l20.3-20.3c10.5,10.5,24.1,13.5,39.1,13.5s29.4-7.5,29.4-20.3-1.5-9.8-5.3-13.5c-3-3-6.8-4.5-14.3-5.3l-19.6-3c-14.3-2.3-24.1-6.8-31.6-13.5-7.5-7.5-12-18.1-12-32.4,0-29.4,21.8-49.7,56.5-49.7s38.4,5.3,52.7,18.8l-20.3,19.6c-9.8-9.8-22.6-11.3-33.1-11.3-17.3,0-24.8,9-24.8,20.3s1.5,8.3,4.5,12c3,3,8.3,5.3,15.1,6l19.6,3c15.1,2.3,24.1,6,30.9,12.8,9,8.3,12.8,19.6,12.8,34.6,0,31.6-26.3,49.7-60.2,49.7v.8c-24.8,0-43.7-5.3-59.5-21.8Z"
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "st1",
			cx: 415.5,
			cy: 503.9,
			r: 59.7
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M424.8,513.2v24.2h-18.5v-24.2h-24.4v-18.5h24.4v-24.2h18.5v24.2h24.2v18.5h-24.2Z"
		})
	]
});
export default SvgSapIcon;
